import { cn } from '@/lib/utils';

/**
 * Selo do bloqueio, SEPARADO do selo de status operacional.
 *
 * Bloqueio e estado operacional são informações independentes: a embarcação está atracada e,
 * em paralelo, bloqueada. Cada um tem seu próprio selo, lado a lado, e nunca um esconde o
 * outro nem se fundem num rótulo só.
 */
interface Props {
  blocked: boolean;
  className?: string;
  size?: 'sm' | 'md';
}

export function BlockedBadge({ blocked, className, size = 'sm' }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full font-semibold',
        size === 'sm' ? 'px-2.5 py-1 text-xs' : 'px-3 py-1.5 text-sm',
        blocked
          ? 'bg-status-blocked/10 text-status-blocked'
          : 'bg-status-running/10 text-status-running',
        className,
      )}
    >
      {blocked ? 'Bloqueada' : 'Desbloqueada'}
    </span>
  );
}
